import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { PageLayout } from 'common/components';

import { withTheme } from 'common/styling/theme';

import { getPartnershipInfo } from '../../_redux';

import { staticStyles, getDynamicStyles } from './style';
import { PartnershipLinksBlock } from '../../_components';

const PartnershipInfoLinksPage = ({ intl, theme, getPartnershipInfo }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  return (
    <PageLayout captionSlug="partnershipLinks">
      <PartnershipLinksBlock getPartnershipInfo={getPartnershipInfo} intl={intl} />

      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </PageLayout>
  );
};

PartnershipInfoLinksPage.propTypes = {
  getPartnershipInfo: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

PartnershipInfoLinksPage.defaultProps = {
  theme: {},
};

const ThemedPartnershipInfoLinksPage = withTheme()(injectIntl(PartnershipInfoLinksPage));

export default connect(() => ({}), {
  getPartnershipInfo: () => getPartnershipInfo.request({ referType: 'refer_partner' }),
})(ThemedPartnershipInfoLinksPage);
export { PartnershipInfoLinksPage };
